import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef, Output, EventEmitter, Input } from '@angular/core';
import { TabPanel } from '@grapecity/wijmo.nav';
import { FlexGrid, GridPanel, CellRangeEventArgs } from '@grapecity/wijmo.grid';
import { KYMW1407Model } from '../kymw1407.model';

/**
 * 検索結果リストを管理するクラス
 *
 * @export KYMW1407SearchResultComponent
 * @class KYMW1407SearchResultComponent
 */
@Component({
  selector: 'app-kymw1407-search-result',
  templateUrl: 'kymw1407-search-result.component.html',
  styleUrls: ['kymw1407-search-result.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1407SearchResultComponent implements OnInit {
  @ViewChild('dgv_PcodeInfoList', { static: true }) dgv_PcodeInfoList: FlexGrid;
  @ViewChild('hli_GoodsImageList', { static: true }) hli_GoodsImageList: ElementRef;
  @ViewChild('hli_UseHistoryImageList', { static: true }) hli_UseHistoryImageList: ElementRef;
  @ViewChild('hli_SearchImageList', { static: true }) hli_SearchImageList: ElementRef;
  @ViewChild('tab_SearchResult', { static: true }) tab_SearchResult: TabPanel;
  @ViewChild('goodsImageGroups', { static: true }) goodsImageGroups: ElementRef;
  @ViewChild('useHistoryImageGroups', { static: true }) useHistoryImageGroups: ElementRef;
  @ViewChild('searchImageGroups', { static: true }) searchImageGroups: ElementRef;
  @ViewChild('a_Product', { static: true }) tabProduct: ElementRef;
  @ViewChild('a_History', { static: true }) tabHistory: ElementRef;
  @ViewChild('a_Search', { static: true }) tabSearch: ElementRef;

  @Input() goodsImageList: Array<any> = null;
  @Input() pcodeList: Array<any> = null;
  @Input() pcodeInfoList: Array<any> = null;
  @Input() useHistoryImageList: Array<any> = null;
  @Input() searchImageList: Array<any> = null;

  @Output() eventBtnSearch_CLICK: EventEmitter<any> = new EventEmitter;
  @Output() eventPcodeList_CHANGE: EventEmitter<any> = new EventEmitter;
  @Output() eventPcodeInfoList_CLICK: EventEmitter<any> = new EventEmitter;
  @Output() eventGoodsImageList_ITEMCLICK: EventEmitter<any> = new EventEmitter;
  @Output() eventUseHistoryImageList_ITEMCLICK: EventEmitter<any> = new EventEmitter;
  @Output() eventSearchImageList_ITEMCLICK: EventEmitter<any> = new EventEmitter;

  public pCode = String('');
  public goodsImageCnt = Number(0);
  public useHitoryImageCnt = Number(0);
  public searchImageCnt = Number(0);

  /**
   *Creates an instance of KYMW1407SearchResultComponent.
   * @param {KYMW1407Model} kymw1407Model
   * @memberof KYMW1407SearchResultComponent
   */
  constructor(
    private kymw1407Model: KYMW1407Model,
  ) {
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1407SearchResultComponent
   */
  public ngOnInit(): void {
    // グリッドデータ変更時イベント
    this.dgv_PcodeInfoList.itemsSourceChanged.addHandler((s: FlexGrid, e: CellRangeEventArgs) => {
      this.dgv_PcodeInfoList.select(-1, -1);
    });
    // グリッド選択時イベント
    this.dgv_PcodeInfoList.selectionChanged.addHandler((s: FlexGrid, e: CellRangeEventArgs) => {
      this.eventPcodeInfoList_CLICK.emit(e);
    });
    // 初期フォーカスをタブにあてる
    setTimeout(() => {
      if (this.tabProduct.nativeElement.classList.contains('wj-state-active')) {
        this.tabProduct.nativeElement.focus();
      } else if (this.tabHistory.nativeElement.classList.contains('wj-state-active')) {
        this.tabHistory.nativeElement.focus();
      } else {
        this.tabSearch.nativeElement.focus();
      }
    }, 50);
  }
}
